function addAnimateClass(el) {
  el.classList.add('animate')
}

function animateConnector(connector) {
  const path = connector.querySelector('.connector-path');
  const pathLength = path.getTotalLength();
  path.style.strokeDasharray = pathLength;
  path.style.strokeDashoffset = pathLength;

  const dots = connector.querySelectorAll('.connector-dot')
  const transformOrigin = '50% 50%'
  return gsap.timeline()
    .to(path, { duration: 0.9, strokeDashoffset: 0 })
    .from(
      dots,
      {
        duration: 0.5,
        stagger: 0.075,
        scale: 0,
        transformOrigin,
        ease: Elastic.easeOut.config(0.9, 0.5),
      },
      0
    );
}

const init = jQuery(function ($) {
  const { gsap } = require('gsap');
  gsap.install(window);
  var ScrollMagic = require('scrollmagic');
  require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js');
  const heroTween = require('./heroAnimation');

  var controller = new ScrollMagic.Controller();

  requestAnimationFrame(() => addAnimateClass(document.getElementById('hero-group')));

  new ScrollMagic.Scene({
    duration: 1500
  }).setTween(heroTween)
    .setPin('#hero-pin')
    .addTo(controller);

  // new ScrollMagic.Scene({
  //   triggerElement: '#video-group',
  //   offset: -300,
  //   reverse: false,
  // })
  //   .setClassToggle('#video-group', 'animate')
  //   .addTo(controller)

  // const connector1Tween = animateConnector(document.getElementById('connector-1'))
  // connector1Tween
  //   .from('#arrow',
  //     {
  //       duration: 0.7,
  //       scale: 0,
  //       transformOrigin: 'center',
  //       ease: Elastic.easeOut.config(1.1, 0.5),
  //     },
  //     0.9
  //   );
  // new ScrollMagic.Scene({
  //   triggerElement: '#connector-1',
  //   reverse: false,
  // })
  //   .setTween(connector1Tween)
  //   .setClassToggle('#testimonials-title', 'animate')
  //   .addTo(controller)

  const slides = document.querySelectorAll('.screenshot-image')
  const screenshotsScene = new ScrollMagic.Scene({
    triggerElement: '#screenshots-trigger',
    offset: 380
  });
  const isMobile = window.matchMedia('(max-width: 1023px)').matches;
  if (isMobile) {
    const screenshotTween = gsap.to('#screenshot-images', {
      xPercent: -100 * (slides.length - 1),
      ease: 'none'
    });
    screenshotsScene
      .duration(window.innerWidth * slides.length - 1)
      .setPin('#screenshots-group').setTween(screenshotTween)
  } else {
    screenshotsScene.setPin('.screenshot-slide-content', { pushFollowers: false });
  }
  screenshotsScene.addTo(controller);

  [...slides].forEach((slide, idx) => {
    const addScene = () => {
      const slideLength = isMobile ? window.innerWidth + 115 : slide.offsetHeight
      new ScrollMagic.Scene({
        triggerElement: '#screenshots-trigger',
        offset: (isMobile ? 300 : 0) + slideLength * idx,
        duration: idx < slides.length - 1 ? slideLength : 0,
      })
        .setClassToggle(`#screenshot-slide-copy-${idx}`, 'animate')
        .addTo(controller)

      if (!isMobile && idx < slides.length - 1) {
        screenshotsScene.duration(screenshotsScene.duration() + slideLength)
      }
    };

    if (!slide.offsetHeight) {
      slide.addEventListener('load', addScene, { once: true });
    } else {
      addScene();
    }
  });

  const connector2Tween = animateConnector(document.getElementById('connector-2'));
  new ScrollMagic.Scene({
    triggerElement: '#connector-2',
    reverse: false,
  })
    .setTween(connector2Tween)
    .addTo(controller);

  new ScrollMagic.Scene({
    triggerElement: '#pitch-group',
    offset: -200,
    reverse: false,
  })
    .setClassToggle('#pitch-group', 'animate')
    .addTo(controller);

  const bullseye = document.getElementById('bullseye');
  const rings = [...bullseye.querySelectorAll('.ring')].reverse();
  const bullseyeTween = gsap.timeline().from(rings, {
    opacity: 0,
    duration: 0.6,
    stagger: {
      each: 0.25,
      repeat: 2,
      yoyo: true,
      ease: 'power2.in',
    },
  })
  new ScrollMagic.Scene({
    triggerElement: bullseye,
    // reverse: false
  })
    .setTween(bullseyeTween)
    .addTo(controller);

  new ScrollMagic.Scene({
    triggerElement: '#actuals-group',
    offset: -200,
    reverse: false,
  })
    .setClassToggle('#actuals-group', 'animate')
    .addTo(controller)

  new ScrollMagic.Scene({
    triggerElement: '#founders-group',
    offset: -200,
    reverse: false,
  })
    .setClassToggle('#founders-group', 'animate')
    .addTo(controller)
});

module.exports = {
  init,
}
